<div class="c">

    <!-- <div class="header">
    <p class="titr">{{publicservice.Texts.Texts['waste-list8']}}</p>
    </div> -->

    <div class="headerback">
        <!-- <button mat-icon-button aria-label="Example icon button with a vertical three dot icon" class="backbtn">
           <mat-icon>arrow_back</mat-icon>
         </button> -->
        <p class="title">{{publicservice.Texts.Texts["waste-list8"]}}</p>

        <button mat-mini-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="backmap()"
            class="backbtn">
            <mat-icon>arrow_forward</mat-icon>
        </button>

    </div>

    <div class="tableicon">
        <div class="r1">
            <div class="wasteitem" (click)="addPlasticClick()">
                <!-- <button mat-fab color="white" style="color:#67b758" aria-label="profile icon">
            <mat-icon>credit_card</mat-icon>
        </button> -->
                <img class="wasteicon" src="assets/images/plastic.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list5']}}</p>
            </div>
            <div class="wasteitem" (click)="addBreadClick()">
                <img class="wasteicon" src="assets/images/bread.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list7']}}</p>
            </div>
            <div class="wasteitem" (click)="addCpuClick()">
                <img class="wasteicon" src="assets/images/cpu.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list10']}}</p>
            </div>
            <div class="wasteitem" (click)="addIronClick()">
                <img class="wasteicon" src="assets/images/iron.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list11']}}</p>
            </div>
            <div class="wasteitem" (click)="addPetClick()">
                <img class="wasteicon" src="assets/images/pet.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list14']}}</p>
            </div>
            <div class="wasteitem" (click)="addAlSabokClick()">
                <img class="wasteicon" src="assets/images/aluminium.png">
            <p class="iconText">{{publicservice.Texts.Texts['waste-list17']}}</p>
        </div>

        </div>
        <div class="r2">
            <div class="wasteitem" (click)="addPaperClick()">
                <img class="wasteicon" src="assets/images/paper.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list2']}}</p>
            </div>
            <div class="wasteitem" (click)="addCannedFoodClick()">
                <img class="wasteicon" src="assets/images/canned-food.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list6']}}</p>
            </div>
            <div class="wasteitem" (click)="addRiceClick()">
                <img class="wasteicon" src="assets/images/rice.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list9']}}</p>
            </div>
            <div class="wasteitem" (click)="addMesClick()">
                <img class="wasteicon" src="assets/images/mes.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list12']}}</p>
            </div>
            <div class="wasteitem" (click)="addBasketClick()">
                <img class="wasteicon" src="assets/images/basket.png">
            <p class="iconText">{{publicservice.Texts.Texts['waste-list15']}}</p>
        </div>
        <div class="wasteitem" (click)="addAlSanginClick()">
            <img class="wasteicon" src="assets/images/aluminium.png">
        <p class="iconText">{{publicservice.Texts.Texts['waste-list18']}}</p>
    </div>
        </div>

        <div class="r3">
            <div class="wasteitem" (click)="addDryWasteClick()">
                <!-- <a routerLink="/get-location">   -->
                <img class="wasteicon" src="assets/images/drywaste.png">
                <!-- </a> -->
                <p class="iconText">{{publicservice.Texts.Texts['waste-list1']}}</p>
            </div>
            <div class="wasteitem" (click)="addBottleClick()">
                <img class="wasteicon" src="assets/images/bottles.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list3']}}</p>
            </div>
            <div class="wasteitem" (click)="addShoesClick()">
                <!-- <a routerLink="/get-location">   -->
                <img class="wasteicon" src="assets/images/rani.png">
                <!-- به جای کفش گذاشتم رانی و مشابه -->
                <p class="iconText">{{publicservice.Texts.Texts['waste-list4']}}</p>
            </div>
            <div class="wasteitem" (click)="addChodanClick()">
                <img class="wasteicon" src="assets/images/chodan.png">
                <p class="iconText">{{publicservice.Texts.Texts['waste-list13']}}</p>
            </div>
            <div class="wasteitem" (click)="addLakClick()">
                <img class="wasteicon" src="assets/images/lak.png">
            <p class="iconText">{{publicservice.Texts.Texts['waste-list16']}}</p>
        </div>
        </div>

    </div>
</div>